/* 標準的な行のテンプレート */
import React from 'react';
import { Form, Col } from 'react-bootstrap';
import '../i18n';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '../Common';
var RowTemplate = function (_a) {
    var label = _a.label, need = _a.need, content = _a.content, disabled = _a.disabled;
    var t = useTranslation().t;
    var is_se = document.getElementById('is-se');
    /**
     * 必須マークの表示を制御する
     * @return boolean
     */
    var isVisibleRequiredMark = function () {
        // null, undefinedの場合はdisabled === falseであるものとみなす
        return !disabled && need;
    };
    return (React.createElement(Form.Row, null,
        React.createElement(Col, { md: 3, className: "field-label" },
            label,
            isVisibleRequiredMark() ? (React.createElement("span", { className: getLanguage() === 'en' && is_se.dataset.value
                    ? 'c-required-item-label-en ml-md-auto'
                    : 'c-required-item-label ml-md-auto' }, t('必須'))) : null),
        React.createElement(Col, { md: 9, className: "field-label-text" }, content)));
};
export default RowTemplate;
